
import { defineComponent } from 'vue'

export default defineComponent({
  components: {},
  props: {
    isApply: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    return { props }
  },
})
